var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRateEmptyLarg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rate_empty_larg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46293",
    d: "M0,0H48V48H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46294",
    d: "M35.857,14.517l-9.68-.84-3.78-8.9a2,2,0,0,0-3.68,0l-3.78,8.92-9.66.82a2,2,0,0,0-1.14,3.5l7.34,6.36-2.2,9.44a2,2,0,0,0,2.98,2.16l8.3-5,8.3,5.02a2,2,0,0,0,2.98-2.16l-2.2-9.46,7.34-6.36a1.991,1.991,0,0,0-1.12-3.5Zm-15.3,12.72-7.52,4.54,2-8.56L8.4,17.458l8.76-.76,3.4-8.06,3.42,8.08,8.76.76-6.64,5.76,2,8.56Z",
    transform: "translate(3.443 3.562)",
    fill: "#f60"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateEmptyLarg);
export default __webpack_public_path__ + "static/media/rate_empty_larg.3d053ccc9ae5f488c2a98004eabd43c0.svg";
export { ForwardRef as ReactComponent };